import SessionEventProto from "../session-event-proto"
import {EntityType} from "../../gd/const/item";

type Header = {
    id              : ID
}

const debug = false
// const debug = "SessionEventDataImportProgress"

export default class SessionEventDataImportProgress extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            id              : sessionEvent.dataImport.id
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        const data = _.cloneDeep(this.data)

        debug && console.log(debug, 'process', data.type, data)

        gd.modelBus.newUpdate(EntityType.DATA_IMPORT, this.method, this.header.id, data, this.header)
    }
}
